var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("view-page", {
    attrs: {
      title: _vm.title,
      loading: _vm.loading,
      "delete-dialog-title": _vm.$t("DeleteCustomField"),
      "delete-dialog-content": _vm.deleteMessage,
      "delete-button": _vm.userHasPermissionTo("destroy"),
      "edit-button": _vm.userHasPermissionTo("update"),
      "permission-name": _vm.permissionName
    },
    on: { editItem: _vm.editItem, deleteItem: _vm.deleteField },
    scopedSlots: _vm._u([
      {
        key: "leftSide",
        fn: function() {
          return [
            _vm._l(_vm.fields, function(field) {
              return _c("view-page-data-field", {
                key: field.template,
                attrs: {
                  icon: field.icon,
                  label: field.label,
                  data: field.data
                }
              })
            }),
            _vm._v(" "),
            _c("app-dialog-box", {
              attrs: {
                open: _vm.confirmDeleteDialog,
                title: _vm.$t("DeleteCustomField"),
                content: _vm.$t("CustomFieldInUse"),
                "main-action-label": _vm.$t("No"),
                "secondary-action-label": _vm.$t("Yes"),
                loading: _vm.loadingDelete
              },
              on: {
                mainAction: function($event) {
                  _vm.confirmDeleteDialog = false
                },
                secondaryAction: _vm.finalDelete
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-102ffaba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-102ffaba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/CustomFields/CustomFieldsDetails.vue
// module id = null
// module chunks = 